import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../../../contexts/userContext";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, loading } = useContext(UserContext);

  // Afficher un message de chargement pendant la vérification de l'authentification
  if (loading) {
    return <p>Chargement...</p>; // Tu peux remplacer par un spinner
  }

  // Redirection vers la page de connexion si l'utilisateur n'est pas connecté
  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
